import './SearchablePeriscopeFieldGroupList.scss';
import { fieldSortOptions } from './FieldSortOptions';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { PeriscopeFieldGroupList } from './PeriscopeFieldGroupList';
import { useQueryResource } from '@hooks';
import {
	ApiCodeToggleQueryParams,
	ReportComponentTypeFilterQueryParams,
	SearchFilterQueryParams,
	SortByFilterQueryParams
} from '../filters';
import { FieldGroup, PeriscopeFieldSearch } from '.';
import { paginationDefaultQueryParams, PaginationQueryParams } from '..';
import React, { useEffect, useState } from 'react';

type Resource = unknown[];
export type SearchablePeriscopeFieldGroupListQueryParams = ApiCodeToggleQueryParams &
	ReportComponentTypeFilterQueryParams &
	PaginationQueryParams &
	SortByFilterQueryParams &
	SearchFilterQueryParams;

export interface SearchablePeriscopeFieldGroupListProps {
	mapGroup?: (record: unknown) => FieldGroup;
	parentIndex: number;
	showParents?: boolean;
	uri: string;
}

export const SearchablePeriscopeFieldGroupList: React.FC<SearchablePeriscopeFieldGroupListProps> = ({
	mapGroup,
	uri,
	...rest
}) => {
	const [ transformedGroups, setTransformedGroups ] = useState<FieldGroup[]>([]);

	const { loading, resource, queryParams, updateParams } = useQueryResource<
		Resource,
		SearchablePeriscopeFieldGroupListQueryParams
	>({
		defaultParams: {
			...paginationDefaultQueryParams,
			sortBy: fieldSortOptions[ 1 ].key,
			sortDirection: fieldSortOptions[ 1 ].direction
		},
		uri
	});

	useEffect(() => {
		if (resource) {
			setTransformedGroups(mapGroup ? resource.map(mapGroup) : (resource as FieldGroup[]));
		}
	}, [ mapGroup, resource ]);

	return (
		<>
			<PeriscopeFieldSearch
				onChange={ updateParams }
				queryParams={ queryParams } />
			<div className='searchable-periscope-field-group-list'>
				<LoadingSpinner spinning={ loading }>
					<PeriscopeFieldGroupList
						{ ...rest }
						groups={ transformedGroups }
						useApiNames={ Boolean(queryParams.useInternal) } />
				</LoadingSpinner>
			</div>
		</>
	);
};
